import React, { useState } from "react";
 
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card"; 
  
import { postRegisterWithoutOrg } from "../../services/cadastro";

const CadastroSemOrg = ({setIsFetching}) => {

	const [nome_usuario, setNome] = useState("");
	 
	const [email, setEmail] = useState("");
	const [senha, setSenha] = useState("");
	const [confirmarSenha, setConfirmarSenha] = useState("");

	const [error, setError] = useState({
		nome_usuario: false,
		 
		email: false,
		senha: false,
		confirmarSenha: false,
	});

	const [helperText, setHelperText] = useState({
		nome_usuario: "",
		 
		email: "",
		senha: "Escreva uma senha com pelo menos 8 caracteres",
	});

	const validateHelperText = (errors) => {
		setHelperText({
			nome_usuario: errors.nome_usuario,
			 
			email: errors.email,
			senha: errors.senha,
			confirmarSenha: errors.confirmarSenha,
		});
	};

	const validateError = (errors) => {
		let aux = {
			nome_usuario: errors.nome_usuario ? true : false,
			 
			email: errors.email ? true : false,
			senha: errors.senha ? true : false,
			confirmarSenha: errors.confirmarSenha ? true : false,
		};

		setError(aux);
	};

	const postUser = (user) => {
		postRegisterWithoutOrg(user)
			.then(function (responses) {

				setIsFetching(false);
			})
			.catch(function (errors) { 
				console.log(errors);

				validateHelperText(errors.response.data);
				validateError(errors.response.data);
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const user = {
			nome_usuario: nome_usuario,
			email: email,
			senha: senha,
			confirmarSenha: confirmarSenha,
			 
		};

		postUser(user);
	}; 

	return (
		<>
			<Form noValidate onSubmit={handleSubmit}>
					<h1>Administrador</h1>
					<div className="p-4">
						<Card variant="contained">
							<div className="row">
								<div className="my-2 col-sm-12 col-md-12 col-lg-12">
									<TextField
										fullWidth
										label="Nome do Usuário"
										helperText={helperText.nome_usuario}
										error={error.nome_usuario}
										value={nome_usuario}
										onChange={(e) =>
											setNome(e.target.value)
										}
									/>
								</div>
								{/* <div className="my-2 col-sm-12 col-md-6 col-lg-6">
									<TextField
										fullWidth
										label="Cargo"
										helperText={helperText.cargo}
										error={error.cargo}
										value={cargo}
										onChange={(e) =>
											setCargo(e.target.value)
										}
									/>
								</div> */}
							</div>
						</Card>

						<Card className="mt-4" variant="contained">
							<div className="row ">
								<div className="my-2 col-sm-12 col-md-12 col-lg-12">
									<TextField
										fullWidth
										label="E-mail Cadastrado"
										error={error.email}
										helperText={helperText.email}
										value={email}
										onChange={(e) =>
											setEmail(e.target.value)
										}
										// onBlur={() => validateEmail()}
									/>
								</div>
							</div>

							<div className="row">
								<div className="my-2 col-sm-12 col-md-6 col-lg-6">
									<TextField
										fullWidth
										label="Senha"
										type="password"
										helperText={helperText.senha}
										error={error.senha}
										value={senha}
										onChange={(e) =>
											setSenha(e.target.value)
										}
										// onBlur={() => validateSenha()}
									/>
								</div>
								<div className="my-2 col-sm-12 col-md-6 col-lg-6">
									<TextField
										fullWidth
										label="Confirmar Senha"
										type="password"
										helperText={helperText.confirmarSenha}
										error={error.confirmarSenha}
										value={confirmarSenha}
										onChange={(e) =>
											setConfirmarSenha(e.target.value)
										}
										// onBlur={() =>
										// 	validateConfirmarSenha()
										// }
									/>
								</div>
							</div>
						</Card>
					</div>

					<div className="d-flex justify-content-center">
						<Button type="submit" variant="outlined">
							Enviar
						</Button>
					</div>
			</Form>
		</>
	);
};

export default CadastroSemOrg;
